export const CUSTOMER_CANCELLATION = 'customer-cancellation';
export const CUSTOMER_UNEXCUSED = 'customer-unexcused';
export const APPLICANT_UNEXCUSED = 'applicant-unexcused';
export const APPLICANT_CANCELLATION = 'applicant-cancellation';
export const APPLICANT_LOST_INTEREST = 'applicant-lost-interest';
export const APPLICANT_SICK = 'applicant-sick';
export const APPLICANT_FORGOT = 'applicant-forgot';